import { Component, inject, signal } from '@angular/core';

import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NZ_MODAL_DATA, NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { ClassificationCodeService, EhrService } from '@beautyapp/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { catchError, throwError } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { SelectComponent } from '../../../../../form/src/lib/select/select.component';

@UntilDestroy()
@Component({
  selector: 'beautyapp-ehr-complete',
  imports: [
    FormsModule,
    NzButtonModule,
    ReactiveFormsModule,
    SelectComponent,
    TranslateModule,
    NzModalModule
],
  templateUrl: './ehr-complete.component.html',
  styleUrl: './ehr-complete.component.scss'
})
export class EhrCompleteComponent {
  data = inject(NZ_MODAL_DATA);
  modal = inject(NzModalRef);
  classificationCodeService = inject(ClassificationCodeService);
  ehrService = inject(EhrService);
  notificationService = inject(NzNotificationService);
  translateService = inject(TranslateService);

  hospitalizationResults = signal(this.classificationCodeService.getHospitalizationResults());
  conditionAtTheMoment = signal(this.classificationCodeService.getConditionAtTheMoment());
  ehrVisibilityStatus = signal(this.classificationCodeService.getEhrVisibilityStatus());
  loading = signal(false);

  form = new FormGroup({
    ehrId: new FormControl<number | null>(this.data.ehrId, Validators.required),
    hospitalizationResult: new FormControl<number | null>(this.data.hospitalizationResult, Validators.required),
    conditionAtTheMoment: new FormControl<number | null>(this.data.conditionAtTheMoment, Validators.required),
    ehrVisibleStatus: new FormControl<number | null>(this.data.ehrVisibleStatus, Validators.required)
  });

  submit() {

    this.form.markAllAsTouched();

    if (this.form.invalid) return;
    this.loading.set(true);

    const { ehrId, hospitalizationResult, conditionAtTheMoment, ehrVisibleStatus } = this.form.value as {
      ehrId: number | null;
      hospitalizationResult: number | null;
      conditionAtTheMoment: number | null
      ehrVisibleStatus: number | null
    };
    this.ehrService.sendEhr({
      ehrId: ehrId,
      hospitalizationResult: hospitalizationResult,
      conditionAtTheMoment: conditionAtTheMoment,
      ehrVisibleStatus: ehrVisibleStatus
    }).pipe(
      untilDestroyed(this),
      catchError((error) => {
        this.loading.set(false);
        const errorMessage = error?.error?.message || error?.message || this.translateService.instant('ehr.errorSending');
        this.notificationService.error(
          this.translateService.instant('error'),
          errorMessage
        );
        return throwError(() => error);
      })
    ).subscribe((res) => {
      this.notificationService.success(
        this.translateService.instant('success'),
        this.translateService.instant('ehr.successfullySent')
      );
      this.loading.set(false);
      this.modal.close(res);
    })

  }
}
